import { render } from "./TaskCard.vue?vue&type=template&id=30f8f3fc&scoped=true"
import script from "./TaskCard.vue?vue&type=script&lang=js"
export * from "./TaskCard.vue?vue&type=script&lang=js"

import "./TaskCard.vue?vue&type=style&index=0&id=30f8f3fc&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30f8f3fc"]])

export default __exports__